import React from 'react';
import { ePermissions } from '../../../types/administration/userAdministration/ePermissions';
import { useListFeaturesQuery } from '../../../API/administration/FeaturesAPI';
import { FeaturesTable } from './FeaturesTable';
import { useHistory } from 'react-router';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { FeaturePresentationCard } from './FeaturePresentationCard';
import { useHasPermissions } from 'components/accessControl/hooks/useHasPermissions';

export const FeaturesContainer: React.FC = () => {
  const history = useHistory();
  const hasReadPermission = useHasPermissions([ePermissions.FeatureRead]);

  const {
    data: sortedFeatures = [],
    error,
    isFetching,
  } = useListFeaturesQuery(undefined, { skip: !hasReadPermission });
  if (!hasReadPermission) {
    history.push(clientUrls.urlFor.administrationIndex());
  }

  return (
    <FeaturePresentationCard
      featureFetchError={error}
      data-test-id={'features-page'}
      hintText={'All features available to toggle.'}
      title={'Features'}
    >
      <FeaturesTable data={sortedFeatures} isFetching={isFetching} />
    </FeaturePresentationCard>
  );
};
